import React from 'react';

function PresetMenuComponent() {
    return <div>PresetMenuComponent</div>;
}

export default PresetMenuComponent;
